import './ArrowToIcon.scss'
import {ReactComponent as ArrowIcon} from 'assets/icons/arrow.svg'

export default function ArrowToIcon(props: any) {
  return <ArrowIcon {...props} className="ArrowToIcon" />
}
